//Base URLs -- Leave empty if video exists in same domain or if absolute path provided in src.
const videoBaseUrl = "https://109spaces.sfo2.cdn.digitaloceanspaces.com/media/optima/video/";
const coverImgBaseUrl = "https://109spaces.sfo2.cdn.digitaloceanspaces.com/media/optima/video/covers/";

const vid = document.getElementById("bgVideo");
const videoSource = document.getElementById("bgVideoSource");
const coverImg = document.getElementById("bgVideoCover");

/* AVAILABLE VIDEO FILES

portrait-4k.mp4
portrait-1440p.mp4
portrait-1080p.mp4
portrait-720p.mp4
portrait-480p.mp4

landscape-4k.mp4
landscape-1440p.mp4
landscape-1080p.mp4
landscape-720p.mp4
landscape-480p.mp4

To download these, just prepend the file name with: https://109spaces.sfo2.cdn.digitaloceanspaces.com/media/optima/video/
 */

//Change video sources and breakpoints here.
const mediaQueries = [
  {
    query: "(min-width:1921px)",
    coverImg: "",
    videoSrc: "landscape-1440p.mp4",
  },
  {
    query: "(min-width:1281px) and (max-width:1920px)",
    coverImg: "",
    videoSrc: "landscape-1080p.mp4",
  },
  {
    query: "(min-width:853px) and (max-width:1280px)",
    coverImg: "",
    videoSrc: "portrait-720p.mp4",
  },
  {
    query: "(max-width:852px)",
    coverImg: "",
    videoSrc: "portrait-480p.mp4",
  },
];

function changeSrc(src, cover) {
  videoSource.setAttribute("src", videoBaseUrl+src);
  coverImg.setAttribute("src", coverImgBaseUrl+cover);
  vid.load();
  vid.play();
}

mediaQueries.forEach((mq) => {
  let mediaQuery = window.matchMedia(mq.query);
  mediaQuery.addEventListener("change", function (e) {
    if (e.matches) changeSrc(mq.videoSrc, mq.coverImg);
  });
  if (mediaQuery.matches) changeSrc(mq.videoSrc, mq.coverImg);
});
